/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_TitleInputs */

const en_notify_title = /** @type {(inputs: Notify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const de_notify_title = /** @type {(inputs: Notify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitteilungen`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Notify_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_title = /** @type {((inputs?: Notify_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_title(inputs)
	return en_notify_title(inputs)
});